module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-vr-fill-d4b059a1.svg";